<template>
    <div class="page-notice">
        <component :is="homeConponent">
        </component>
    </div>
</template>

<script>
import {buildTdk} from '@config/tdk';
import common from './sections/common.vue';  // hyc
import hzyc from './sections/hzyc.vue';

export default {
    head() {
        var tdk = (buildTdk('news'));
        tdk.title = tdk.title + '·' + tdk.webName;
        return tdk
    },
    components: {
        common,
        hzyc,
    },

    data () {
        return {
            homeConponent:null,
        };
    },
    created() {
        this.homeConponent = 'common';

        if (this.webInfo.id == 'hzc') {
            this.homeConponent = common;
        } else {
            this.homeConponent = hzyc;
        }
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
</style>